import { canUsePermission } from "../../../lib/auth";
import type { ResourcePointListScope, ResourcePointSpuItem } from "../types";

export const resourcePointPermissions = {
  enterprise: { access: "resource.enterprise:access", manage: "resource.enterprise:manage", delete: "resource.enterprise:delete" },
  intangible: { access: "resource.intangible:access", manage: "resource.intangible:manage", delete: "resource.intangible:delete" },
  other: { access: "resource.point:access", manage: "resource.point:manage", delete: "resource.point:delete" },
  railway: { access: "resource.railway_station:access", manage: "resource.railway_station:manage", delete: "resource.railway_station:delete" },
  airport: { access: "resource.airport:access", manage: "resource.airport:manage", delete: "resource.airport:delete" },
} as const;

/** 按真实资源类别控制全量页和各分类页的行级操作。 */
export function canUseResourcePoint(
  user: Parameters<typeof canUsePermission>[0],
  target: ResourcePointListScope | Pick<ResourcePointSpuItem, "pointType" | "pointSubType"> | null,
  action: "access" | "manage" | "delete",
): boolean {
  if (!target) return false;
  if (user?.isSuperuser) return true;
  let scope: ResourcePointListScope | undefined;
  if (typeof target === "string") scope = target;
  else if (["火车站", "车站"].includes(target.pointType)) scope = "railway";
  else if (target.pointType === "机场") scope = "airport";
  else if (target.pointType === "考察点") {
    if (target.pointSubType === "2") scope = "enterprise";
    else if (target.pointSubType === "6") scope = "intangible";
    else if (["1", "3", "4", "5", "7", "8", "21", "22"].includes(target.pointSubType ?? "")) scope = "other";
  }
  if (!scope) return false;
  const candidates = scope === "all" ? Object.values(resourcePointPermissions) : [resourcePointPermissions[scope]];
  return candidates.some((codes) => canUsePermission(user, codes.access) && canUsePermission(user, codes[action]));
}
